<template>
    <div class="login-body">
        <!--登录注册顶部-->
        <backindex></backindex>
        <div class="login-title">{{$t("loginPage")}}</div>
        <div class="login-area">
            <div class="login-name">
                <div class="name-font">{{$t("memAccount")}}</div>
                <div class="login-input">
                    <input type="text" v-model="name" :placeholder="tips1">
                </div>
            </div>
            <div class="login-pass">
                <div class="pass-font">{{$t("memPwd")}}</div>
                <div class="login-input">
                    <input type="password" v-model="password" :placeholder="tips2">
                </div>
            </div>
        </div>
        <!--按钮区域-->
        <div class="btn-area">
            <div class="login-btn" @click="login">{{$t("memLogin")}}</div>
            <div class="btn-or">
                <div class="or-line"></div>
                <span>or</span>
                <div class="or-line"></div>
            </div>
            <div class="reg-btn" @click="goReg">{{$t("memReg")}}</div>
            <div style="margin-top:1rem;">
              <div class="fb-btn" @click="fblogin">Facebook{{$t("memLogin")}}</div>
            </div>
        </div>
        <!--底部组件-->
        <div class="login-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
import backindex from "@/components/common/backindex";
import pagebottom from "@/components/common/pagebottom";
export default {
  name: "login",
  components: {
    pagebottom,
    backindex
  },
  data() {
    return {
      name: "",
      password: "",
      tips1: "电子邮箱/手机号码/昵称",
      tips2: "请输入密码"
    };
  },
  mounted: function() {
    this.tips1 = this.$t("inputAccount");
    this.tips2 = this.$t("inputPwd");
    //默认设置用户名，密码
    this.name = localStorage.getItem("myyueln");
    this.password = localStorage.getItem("myyuelp");
  },
  methods: {
    //跳转注册页
    goReg() {
      this.go.goReg();
    },
    fblogin() {
      let _this = this;
      FB.login(
        function(response) {

          console.info(response);
          
          if (response.status == "connected") {
            FB.api('/me', function(response) {
                  console.log(response);
                _this.req.userBind(response.id,response.name).then(res=>{
                  if (res && res.status == 1) {
                    localStorage.setItem("loginUserID", res.data.id);
                    //如果有回跳，跳转至回跳
                    var url = JSON.parse(localStorage.getItem("loginBack"));
                    if (url) {
                      localStorage.removeItem("loginBack");
                      _this.$router.push(url);
                    } else {
                      _this.go.backIndex();
                    }
                  }
                });
              });
          }
        }, {scope: 'public_profile,email,user_gender',auth_type:"rerequest"}
      ); //需要获取的信息scope
    },
    //登录
    login(e) {
      this.req.login(this.name, this.password).then(res => {
        if (res && res.status == 1) {
          localStorage.setItem("myyueln", this.name);
          localStorage.setItem("myyuelp", this.password);

          localStorage.setItem("loginUserID", res.data.id);
          //如果有回跳，跳转至回跳
          var url = JSON.parse(localStorage.getItem("loginBack"));
          if (url) {
            localStorage.removeItem("loginBack");
            this.$router.push(url);
          } else {
            this.go.backIndex();
          }
        }
      });
    }
  }
};
</script>
<style scoped>
.login-body {
  width: 100%;
  height: 100%;
}
.login-bottom {
  width: 100%;
  height: auto;
  margin-top: 2em;
  bottom: 0;
  left: 0;
}
.fb-btn {
  width: 5.8rem;
  height: 0.84rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.84rem;
  text-align: center;
  color: #fff;
  border-radius: 0.08rem;
  background: #4267b2;
  border: 1px solid #4267b2;
}
.login-title {
  width: 100%;
  height: 1.33rem;
  background: #ffffff;
  border-bottom: 0.02rem solid #e6e6e6;
  font-size: 0.34rem;
  color: #ff1f4f;
  text-align: center;
  line-height: 1.33rem;
  font-weight: 700;
}
.login-area {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-left: 0.4rem;
  padding-bottom: 1rem;
}
.login-name,
.login-pass {
  width: 100%;
  padding: 0.5rem 0 0 0;
  display: flex;
  justify-content: space-between;
}
.name-font,
.pass-font {
  font-size: 0.3rem;
  font-weight: 700;
}
.login-input {
  width: 5.25rem;
  border-bottom: 0.02rem solid #e6e6e6;
  padding: 0.06rem 0 0.5rem;
}
.login-input input {
  font-size: 0.26rem;
  line-height: 0.32rem;
  border: none;
  outline: none;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding-left: 0.2rem;
}
input::placeholder {
  color: #666666;
}
/*按钮区域*/
.btn-area {
  width: 100%;
  height: auto;
}
.login-btn,
.reg-btn {
  width: 5.8rem;
  height: 0.84rem;
  box-sizing: border-box;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.84rem;
  text-align: center;
  border-radius: 0.08rem;
}
.login-btn {
  background: #ff1f4f;
  color: #ffffff;
}
.reg-btn {
  border: 0.02rem solid #ff1f4f;
  color: #ff1f4f;
}
.btn-or {
  width: 100%;
  padding: 0.4rem 0;
  text-align: center;
  font-size: 0.2rem;
  line-height: 0.2rem;
  color: #999999;
}
.btn-or span {
  padding: 0 0.26rem;
  font-weight: 700;
}
.or-line {
  display: inline-block;
  vertical-align: middle;
  width: 0.32rem;
  height: 0.02rem;
  background: #999999;
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue